import React, { Component } from 'react';
import { StyleSheet, css } from 'aphrodite';

import { FormControl, Grid, TableCell, TextField } from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';

import { Helper } from '../helpers/Helper';
import { BaseEntityPage } from './BaseEntityPage';
import { AppConfig } from '../../AppConfig';
import { AppTheme } from '../../styles/AppTheme';
import { CommonTheme } from '../../styles/Styles';
import TableCard from './tables/TableCard';
import { StatCard } from './StatCard';
import { AppButton } from './AppButton';

function formatAmount(value, currency) {
  const currencyCode = currency || AppConfig.DEFAULT_CURRENCY
  try {
    return Number(value).toLocaleString(currencyCode === 'INR' ? 'en-IN' : 'en-US', { style: 'currency', currency: currencyCode })
  } catch (err) {
    return Number(value).toFixed(2) + ' ' + currencyCode
  }
}

function generateTransactionsReport(transactions) {
  const reportHeaders = ['Date', 'Comment', 'Amount Used', 'Amount Added', 'Balance']
  const textColumnIndices = [0, 1]

  const data = transactions.map((item) => {
    if(item) {
      return([
        Helper.formatTimestamp(item.createdTs),
        { title: item.title, subTitle: item.subTitle },
        item.txType === 'DEBIT' ? '−' + formatAmount(item.amount / 100, item.currency) : '',
        item.txType === 'CREDIT' ? '+' + formatAmount(item.amount / 100, item.currency) : '',
        (item.balance !== undefined && item.balance !== null) ? formatAmount(item.balance / 100, item.currency) : '',
      ])
    }
  }).filter(a => !!a)

  return {
    headers: reportHeaders,
    rows: data,
    textColumnIndices: textColumnIndices,
    renderCustomTableBody: (cellValue, columnIndex) => {
      if(columnIndex === 1) {
        return(
          <TableCell key={columnIndex} className={css(Styles.cellBody, Styles.commentCell)}>
            <div className={css(Styles.infoCell)}>
              {cellValue && cellValue.title && <span className={css(Styles.infoField)}>{cellValue.title}</span>}
              {cellValue && cellValue.subTitle && <span className={css(Styles.line2)}>{cellValue.subTitle}</span>}
            </div>
          </TableCell>
        )
      }
      if(columnIndex === 2 || columnIndex === 3 || columnIndex === 4) {
        return(
          <TableCell key={columnIndex} className={css(Styles.cellBody, Styles.amountCell, columnIndex === 3 && Styles.amountAdded)}>
            {cellValue}
          </TableCell>
        )
      }
      return null
    }
  }
}

function generateUsageRatesReport(rates, currency) {
  const reportHeaders = ['Service', 'Rate']
  const textColumnIndices = [0]

  const data = rates.map((item) => {
    if(item) {
      return([
        { label: item.purposeLabel, unitLabel: item.unitLabel },
        (item.price !== undefined && item.price !== null) ? formatAmount(item.price / 100, item.currency || currency) : '-',
      ])
    }
  }).filter(a => !!a)

  return {
    headers: reportHeaders,
    rows: data,
    textColumnIndices: textColumnIndices,
    renderCustomTableBody: (cellValue, columnIndex) => {
      if(columnIndex === 0) {
        return(
          <TableCell key={columnIndex} className={css(Styles.cellBody, Styles.commentCell)}>
            <div className={css(Styles.infoCell)}>
              {cellValue && cellValue.label && <span className={css(Styles.infoField)}>{cellValue.label}</span>}
              {cellValue && cellValue.unitLabel && <span className={css(Styles.line2)}>{cellValue.unitLabel}</span>}
            </div>
          </TableCell>
        )
      }
      if(columnIndex === 1) {
        return(
          <TableCell key={columnIndex} className={css(Styles.cellBody, Styles.amountCell)}>
            {cellValue}
          </TableCell>
        )
      }
      return null
    }
  }
}

function UsageRates(props) {
  return (
    <div className={css(Styles.usageRatesContainer)}>
      <TableCard
        isModalTable={true}
        compactEmpty={true}
        disableTooltip={true}
        item={{data: generateUsageRatesReport(props.rates || [], props.currency)}}
        containerStyle={Styles.usageRatesTable}
        cellWidths={{Rate: Styles.amountHeadCell}}/>
    </div>
  )
}

class AddFunds extends Component {

  constructor(props) {
    super(props)
    this.field = this.props.fieldDef.steps[0].fields[0]
    this.state = {
      creditPack: this.field.options.find(option => option.key === this.field.defaultValue) || this.field.options[0],
    }
  }

  render() {
    const field = this.field
    const creditPack = this.state.creditPack

    return (
      <div className={css(Styles.dialogContainer)}>
        <div className={css(Styles.formControlContainer)}>
          <p className={css(Styles.label)}>{field.label}{field.v_required && field.v_required.value && ' *'}</p>
          <FormControl className={css(Styles.formControlMainFilters)} variant='outlined'>
            <Autocomplete
              value={creditPack}
              options={field.options}
              onChange={(e, val) => val && this.setState({ creditPack: val })}
              getOptionLabel={(option) => formatAmount(option.label, field.currency)}
              getOptionSelected={(option, value) => option.key === value.key}
              disableClearable
              classes={{ popper: css(Styles.dialog) }}
              renderInput={params =>
                <TextField
                  {...params}
                  variant={'standard'}
                  className={css(Styles.formControlFilters)}
                  InputProps={{
                    ...params.InputProps,
                    disableUnderline: true,
                    readOnly: true,
                    classes: {
                      root: css([Styles.textInputStyles, Styles.autoCompleteInputRoot]),
                      input: css(Styles.formInputStyle, Styles.textInput),
                    },
                  }} />}
            />
          </FormControl>
        </div>
        {creditPack && <div className={css(Styles.summaryContainer)}>
          <div className={css(Styles.summaryRow)}>
            <span className={css(Styles.summaryLabel)}>{'Amount'}</span>
            <span>{formatAmount(creditPack.price, field.currency)}</span>
          </div>
          <div className={css(Styles.summaryRow)}>
            <span className={css(Styles.summaryLabel)}>{`${field.taxLabel} (${field.taxPercent}%)`}</span>
            <span>{formatAmount(creditPack.tax, field.currency)}</span>
          </div>
          <div className={css(Styles.summaryRow, Styles.summaryTotal)}>
            <span>{'Total payable'}</span>
            <span className={css(Styles.summaryTotalValue)}>{formatAmount(creditPack.total, field.currency)}</span>
          </div>
        </div>}
        {creditPack && <div className={css(Styles.dialogFooter)}>
          <AppButton
            buttonText={'Pay ' + formatAmount(creditPack.total, field.currency)}
            onClick={() => this.props.onSubmit(creditPack)}
          />
        </div>}
      </div>
    )
  }
}

export class UsageWallet extends BaseEntityPage {

  constructor(props) {
    super(props)
    this.orgId = this.props.match.params.orgId || 'PRODUCT'
    this.pageTitle = Helper.getString('usage-wallet')
    this.pageKey = 'usage-wallet'
    this.breadCrumbs = [
      { title: Helper.getString('home'), to: this.baseRoute() },
      { title: this.pageTitle },
    ]
    this.toFetch = [
      { key: 'walletHistory', ms: AppConfig.CDP_MS.ENDPOINT, method: 'GET', paths: ['miscs', 'wallet-history'], queryParams: { orgId: this.orgId } },
    ]
    this.headerActions = []
    this.apiData = {}
  }

  onFetchSuccess(results) {
    this.setState({
      usageWallet: this.getResult(results, 'walletHistory'),
    })
  }

  openUsageRates() {
    this.openModalForCustomPageDialog({
      pageTitle: 'Usage Rates',
      CustomPageDialogComp: UsageRates,
      rates: this.state.usageWallet.usageRates,
      currency: this.state.usageWallet.currency,
    })
  }

  openAddFunds() {
    const creditPacksFieldDef = this.state.usageWallet.creditPacksFieldDef
    this.openModalForCustomPageDialog({
      pageTitle: creditPacksFieldDef.title,
      CustomPageDialogComp: AddFunds,
      fieldDef: creditPacksFieldDef,
      onSubmit: (creditPack) => this.customSubmitForAddFunds(creditPack),
    })
  }

  renderAboveTable() {
    const usageWallet = this.state.usageWallet

    return (
      <div className={css(Styles.walletSummaryContainer)}>
        {usageWallet && <Grid container className={css(Styles.balanceContainer)}>
          <StatCard
            xs={12}
            sm={12}
            text={formatAmount((usageWallet.currentBalance || 0) / 100, usageWallet.currency)}
            subText={'CURRENT BALANCE'}
            cardIndex={2}
            padding={'small'}
          />
        </Grid>}
        <div className={css(Styles.walletActionsContainer)}>
          {usageWallet && usageWallet.usageRates && usageWallet.usageRates.length > 0 && <AppButton
            buttonText={'View Usage Rates'}
            icon={'receipt_long'}
            onClick={() => this.openUsageRates()}
            buttonStyle={[Styles.outlineButton, Styles.walletActionButton]}
            buttonTextStyle={[Styles.outlineButtonText, Styles.walletActionButtonText]}
            iconContainerStyle={[Styles.outlineButtonIconContainer, Styles.walletActionIconContainer]}
          />}
          {/* TODO: enable once the add funds API is available
          {usageWallet && usageWallet.creditPacksFieldDef && <AppButton
            buttonText={'Add Funds'}
            icon={'add'}
            onClick={() => this.openAddFunds()}
            buttonStyle={Styles.walletActionButton}
            buttonTextStyle={Styles.walletActionButtonText}
            iconContainerStyle={Styles.walletActionIconContainer}
          />}
          */}
        </div>
      </div>
    )
  }

  renderBelowTable() {
    const usageWallet = this.state.usageWallet
    const report = generateTransactionsReport((usageWallet && usageWallet.items) || [])

    return (
      <div className={css(Styles.outerContainer)}>
        <div className={css(Styles.tableStatItem)}>
          <TableCard
            item={{data: report, title: 'Transaction History', maxRows: 100}}
            showMoreInTable={true}
            cellWidths={{Date: Styles.dateCell, 'Amount Used': Styles.amountHeadCell, 'Amount Added': Styles.amountHeadCell, Balance: Styles.amountHeadCell}}
            // TODO: enable once the statement download API is available
            // tableActions={usageWallet && usageWallet.statementFieldDef && [
            //   {
            //     label: 'Download',
            //     icon: 'download',
            //     onClick: () => this.openModalForAdd(JSON.parse(JSON.stringify(usageWallet.statementFieldDef)))
            //   }
            // ]}
          />
        </div>
      </div>
    )
  }

  customSubmitForAddFunds(creditPack) {
    // TODO: call the add funds / payment API once it is available
    this.setState({ customPageDialogOpen: false })
  }

  async customSubmitForStatement(options) {
    // TODO: call the statement download API once it is available
    this.setState({ modalOpen: false })
  }

  async customSubmit(options) {
    const { formData, caller } = options
    if (formData.ym) { return this.customSubmitForStatement(options) }
    return caller.submit.call(caller, formData, true)
  }

}

export const Styles = StyleSheet.create({
  outerContainer: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
  },
  tableStatItem: {
    flex: 1,
    minWidth: '100%',
    height: '100%',
    maxWidth: window.innerWidth - AppTheme.drawerWidth - (AppTheme.adminPagePadding * 2),
    '@media (max-width: 767px)': {
      width: '100%',
      alignSelf: 'center',
      paddingLeft: '16px',
      paddingRight: '16px',
    },
  },
  cellBody: {
    backgroundColor: 'white',
    color: CommonTheme.textColor,
    borderBottom: '1px solid ' + AppTheme.borderColor,
    fontSize: 16,
    textAlign: 'center',
    padding: '16px 5px',
    verticalAlign: 'middle',
    '@media (max-width: 767px)': {
      fontSize: 10,
      padding: '16px 2px',
    },
  },
  dateCell: {
    width: '22%',
  },
  amountHeadCell: {
    width: '15%',
    textAlign: 'right',
  },
  amountCell: {
    textAlign: 'right',
    fontWeight: 700,
    whiteSpace: 'nowrap',
  },
  amountAdded: {
    color: '#1E8E3E',
  },
  commentCell: {
    textAlign: 'left',
    whiteSpace: 'normal',
  },
  infoCell: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'flex-start',
    gap: 2,
    minWidth: 0,
  },
  infoField: {
    display: 'block',
  },
  line2: {
    fontSize: 14,
    color: CommonTheme.subTextColor,
    '@media (max-width: 767px)': {
      fontSize: 10,
    },
  },
  walletSummaryContainer: {
    width: '100%',
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    alignItems: 'flex-end',
    gap: 12,
    marginBottom: 60,
  },
  balanceContainer: {
    flex: '0 1 300px',
    '@media (max-width: 767px)': {
      flex: '1 1 100%',
    },
  },
  walletActionsContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: 10,
    '@media (max-width: 767px)': {
      width: '100%',
      flexWrap: 'nowrap',
    },
  },
  walletActionButton: {
    '@media (max-width: 767px)': {
      flex: 1,
      padding: '0 8px',
    },
  },
  walletActionButtonText: {
    whiteSpace: 'nowrap',
    '@media (max-width: 767px)': {
      fontSize: 14,
    },
  },
  walletActionIconContainer: {
    '@media (max-width: 767px)': {
      marginRight: 6,
    },
  },
  outlineButton: {
    border: '1px solid #E5E5E5',
    backgroundColor: AppTheme.secondaryBg,
  },
  outlineButtonText: {
    color: AppTheme.primaryColor,
  },
  outlineButtonIconContainer: {
    border: 0,
    padding: 0,
    color: AppTheme.primaryColor,
  },
  dialogContainer: {
    width: 440,
    display: 'flex',
    flexDirection: 'column',
    gap: 16,
    paddingBottom: 10,
    '@media (max-width: 767px)': {
      width: '100%',
    },
  },
  usageRatesContainer: {
    width: 440,
    display: 'flex',
    '@media (max-width: 767px)': {
      width: '100%',
    },
  },
  usageRatesTable: {
    padding: 0,
    '@media (max-width: 1024px)': {
      padding: 0,
    },
  },
  dialogFooter: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  summaryContainer: {
    backgroundColor: '#F5F5F5',
    borderRadius: 10,
    padding: '14px 16px',
    display: 'flex',
    flexDirection: 'column',
    gap: 10,
    fontSize: 12,
  },
  summaryRow: {
    display: 'flex',
    justifyContent: 'space-between',
    gap: 12,
  },
  summaryLabel: {
    color: CommonTheme.subTextColor,
  },
  summaryTotal: {
    borderTop: '1px solid #E5E5E5',
    paddingTop: 10,
    alignItems: 'baseline',
    fontWeight: 700,
  },
  summaryTotalValue: {
    fontSize: 20,
    fontWeight: 900,
  },
  formControlContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'flex-start',
    gap: 5,
  },
  label: {
    fontSize: 14,
    color: CommonTheme.subTextColor,
    margin: 0,
    display: 'inline-block'
  },
  formControlMainFilters: {
    width: '100%',
  },
  formControlFilters: {
    borderRadius: AppTheme.borderRadius,
    border: '1px solid #E5E5E5',
    overflow: 'hidden',
    boxSizing: 'border-box',
  },
  dialog: {
    zIndex: 130000,
    fontSize: 16,
    color: '#222222',
  },
  textInputStyles: {
    padding: '11px 20px',
    flex: 1,
    textAlign: 'left',
    color: '#222222',
    fontSize: 16
  },
  autoCompleteInputRoot: {
    paddingRight: 48,
    '@media (max-width: 440px)': {
      paddingRight: 18,
    },
  },
  formInputStyle: {
    '::-webkit-scrollbar': {
      display: 'none'
    }
  },
  textInput: {
    padding: '4px 0px',
    '@media (max-width: 440px)': {
      fontSize: 12,
    },
  },
})
